import template from './company-benefits.html';
import controller from './company-benefits.controller';

let companyBenefitsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default companyBenefitsComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/company-benefits/company-benefits.component.js